import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalStateService {
  isAdminAccessEvent: EventEmitter<boolean>;
  hideIntercomDummyEvent: EventEmitter<boolean>;
  isAuthenticated: BehaviorSubject<any> = new BehaviorSubject('');
  datadogInitiated: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isAppAssigned: BehaviorSubject<boolean> = new BehaviorSubject(false);
  userConnection: BehaviorSubject<any> = new BehaviorSubject('');

  constructor() {
    this.isAdminAccessEvent = new EventEmitter<boolean>();
    this.hideIntercomDummyEvent = new EventEmitter<boolean>();
  }
  /**
   * Set user sites to state
   */
  setUserAuthentication(isLogin) {
    this.isAuthenticated.next(isLogin);
  }

  /**
   * Get user sites
   */
  getUserAuthentication() {
    let isAuth: any;
    this.isAuthenticated.subscribe((data: any) => {
      isAuth = data;
    });
    return isAuth;
  }

  /**
   * Set user sites to state
   */
  setUserConnection(connection) {
    this.userConnection.next(connection);
  }

  /**
   * Get user sites
   */
  getUserConnection() {
    let connection: any;
    this.userConnection.subscribe((data: any) => {
      connection = data;
    });
    return connection;
  }

  /**
   * Set user has admin access to state
   */
  setAdminAccess(access) {
    this.isAdminAccessEvent.emit(access);
  }

  /**
   * Set user has admin access to state
   */
  intercomBtnState(state) {
    this.hideIntercomDummyEvent.emit(state);
  }

  /**
   * Set datadog state
   */
  setDatadogState(isLogin) {
    this.datadogInitiated.next(isLogin);
  }

  /**
   * Get datadog state
   */
  getDatadogState() {
    let datadog: any;
    this.datadogInitiated.subscribe((data: any) => {
      datadog = data;
    });
    return datadog;
  }

  /**
   * Set datadog state
   */
  setAppAssignState(isLogin) {
    this.isAppAssigned.next(isLogin);
  }

  /**
   * Get datadog state
   */
  getAppAssignState() {
    let appAssigned: any;
    this.isAppAssigned.subscribe((data: any) => {
      appAssigned = data;
    });
    return appAssigned;
  }
}
